import { TextField, Button, Box, Typography } from "@mui/material";
import { useState } from "react";
import React from "react";
import HomeIcono from "../../components/HomeIcon/HomeIcono";

const Login: React.FC = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  // Aquí puedes usar simpleData() como desees, por ejemplo, imprimirlo en la consola

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    // Aquí puedes manejar el envío del formulario, como enviar los datos a una API

    console.log("Formulario enviado");
  };

  return (
    <>
    <HomeIcono></HomeIcono>
      <Typography
        variant="h2"
        component="h2"
        align="center"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: 40,
          lineHeight: 1.2,
          fontWeight: 900,

          color: "black",
        }}
      >
        !SHALOM¡
      </Typography>

      <Typography
        variant="h2"
        component="h2"
        align="center"
        sx={{
          fontFamily: "Poppins, sans-serif",
          fontSize: 40,
          lineHeight: 1.2,
          fontWeight: 900,
          marginBottom: 5,
          color: "black",
        }}
      >
        NOS ALEGRA DE QUE ESTES AQUÍ
      </Typography>

      <Box
        sx={{
          maxWidth: 400,
          margin: "auto",
          padding: 2,
          backgroundColor: "#029988",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={handleSubmit}>
          <TextField
            label="Correo Electrónico"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            fullWidth
            margin="normal"
            sx={{
              backgroundColor: "#9ad1bf",
              borderRadius: "10px",
              "& fieldset": { borderRadius: "10px" },
            }}
          />
          <TextField
            label="Contraseña"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
            fullWidth
            margin="normal"
            sx={{
              backgroundColor: "#9ad1bf",
              borderRadius: "10px",
              color: "black",
              "& .MuiInputBase-input": { color: "black" },
              "& fieldset": { borderRadius: "10px" },
            }}
          />
        </form>

        <Typography
          variant="body1"
          component="p"
          align="center"
          sx={{ marginTop: 2 }}
        >
          ¿No tienes cuenta?{" "}
          <a href="/register" style={{ color: "#fec93b" }}>
            Registrarse
          </a>
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center", // Centra el botón horizontalmente
          marginTop: 3,
        }}
      >
        <Button
          type="submit"
          variant="contained"
          size="large"
          sx={{
            backgroundColor: "#ffc107",
            color: "black",
            fontFamily: "Poppins, sans-serif",
            fontSize: "20px",
            fontWeight: "bold",
            borderStyle: "solid",
            borderWidth: "2px",
            borderRadius: "5px",
          }}
        >
          Iniciar sesión
        </Button>
      </Box>
    </>
  );
};

export default Login;
